import { Theme } from '@desygner/ui-common-components';

export const page = {
  thumbnail: {
    allowedSizes: {
      small: 344,
      medium: 877,
      large: 1754
    }
  }
};

export const mobile = {
  zoomFactor: 0.7
};

export const timeout = {
  lockDownloadButtonDuringActions: 60000,
  topLoader: 60000,
  socket: 1000 * 60
};

export const sidebar = {
  thumbnail: {
    masonryConfig: {
      gutter: 12,
      columnWidth: 135,
      fitWidth: true
    },
    masonryRefreshTime: 1000
  }
};

export const smartAssets = {
  attributes: {
    userInput: 'custom-placeholder',
    userInputSmartAsset: 'data-uisa',
    definedAsset: 'data-defined-placeholder',
    definedContentType: 'data-defined-content-type'
  },
  assetsByType: {
    background: ['image', 'color'],
    image: ['image'],
    logo: ['logo'],
    shape: ['color'],
    text: ['text', 'color', 'font']
  },
  types: [
    'colors',
    'fonts',
    'icons',
    'images',
    'logos',
    'texts'
  ],
  typeToProperty: {
    colors: 'color',
    fonts: 'font',
    icons: 'icon',
    Icon: 'icon',
    images: 'image',
    Image: 'image',
    logos: 'logo',
    Logo: 'logo',
    texts: 'text'
  },
  descriptionalTypes: [
    'colors',
    'fonts'
  ]
};

export const cookies = {
  loadKey: 'editor_load',
  loadPrintOptionKey: 'editor_load_print',
  loadReferrerOptionKey: 'editor_load_referrer',
  loadThumbnailOptionKey: 'editor_load_thumbnail',
  loadAddonsOptionKey: 'editor_load_addons',
  loadWorkspaceOptionKey: 'editor_load_workspace',
  loadReviewModeOptionKey: 'editor_load_review_mode',
  loadTranslationDataOptionKey: 'editor_load_translation_data',
  loadBackgroundUrlOptionKey: 'editor_load_background_url',
  loadViewOptionKey: 'editor_load_view',
  loadBackUrlOptionKey: 'editor_load_back_url'
};

export const featureFlag = {
  addOn: 'white_label',
  workflow: 'workflow',
  templateRestrictions: 'template_restrictions',
  keys: {
    restrictionsOverview: 'hide_restrictions_overview',
    smartAssets: 'show_smart_assets',
    templateGranularPermission: 'enable_template_granular_permission'
  }
};

export const text = {
  paragraphAttributesMap: {
    line_margin: 0,
    first_line_margin: 0,
    right_margin: 0,
    line_spacing: 0,
    paragraph_spacing: 0,
    alignmentArray: '',
    headingArray: 0,
    triggeredArray: false,
    bulletStyleArray: 0,
    orderedStyleArray: 0,
    orderedNumberingStyleArray: 0,
    orderedRegexArray: '',
    bulletArray: 0,
    customBulletSymbolArray: null,
    bulletFillArray: 0,
    bulletFontSizeArray: 0,
    bulletFontStyleArray: null,
    bulletHighlightArray: null,
    bulletWidthArray: 0,
    bulletFontFamilyArray: 0,
    bulletCustomFontIdArray: 0,
    orderedArray: 0,
    orderedStartArray: null,
    orderedFillArray: 0,
    orderedFontSizeArray: 0,
    orderedWidthArray: 0,
    orderedFontFamilyArray: 0,
    orderedFontWeightArray: 0,
    orderedFontStyleArray: null,
    orderedHighlightArray: null,
    orderedCustomFontIdArray: 0
  },
  partialStylingAttributeMap: {
    'baseline-shift': undefined,
    'custom-font-id': undefined,
    'font-stretch': undefined,
    'data-paragraph-style': undefined,
    'custom-placeholder': undefined,
    'data-defined-placeholder': undefined,
    'data-meta': undefined,
    'font-size': 0,
    'font-weight': 'normal',
    'font-style': 'normal',
    'font-family': 'Nunito',
    'text-decoration': undefined,
    fill: '#000000',
    highlight: 'none',
    link: undefined
  },
  hyperLink: {
    fill: '#0D7FFF'
  },
  bulletPoints: {
    fontFamily: 'Source Code Pro', // Unicode supported by renderer
    marginIndent: 12,
    shortcut: '- ',
    defaultSymbols: ['•', '○', '●', '⁃', '‐', '◦', '▸', '￭', '⏵'],
    symbolMap: {
      1: '•', // U+2022
      2: '◦', // U+25E6
      3: '‐', // U+2010
      4: '▸', // U+25B8
      0: '￭' // U+FFED
    },
    defaultStyleId: 1,
    styles: {
      1: {
        mode: 'd',
        symbols: ['•', '◦', '￭', '•', '◦', '￭', '•', '◦', '￭'],
        charCodes: ['U+2022', 'U+25E6', 'U+FFED', 'U+2022', 'U+25E6', 'U+FFED', 'U+2022', 'U+25E6', 'U+FFED']
      },
      2: {
        mode: 'd',
        symbols: ['‐', '￭', '•', '‐', '￭', '•', '‐', '￭', '•'],
        charCodes: ['U+2010', 'U+FFED', 'U+2010', 'U+2010', 'U+FFED', 'U+2010', 'U+2010', 'U+FFED', 'U+2010']
      },
      3: {
        mode: 'd',
        symbols: ['▸', '◦', '￭', '▸', '◦', '￭', '▸', '◦', '￭'],
        charCodes: ['U+25B8', 'U+25E6', 'U+FFED', 'U+25B8', 'U+25E6', 'U+FFED', 'U+25B8', 'U+25E6', 'U+FFED']
      },
      4: {
        mode: 'd',
        symbols: ['￭', '▸', '•', '￭', '▸', '•', '￭', '▸', '•'],
        charCodes: ['U+FFED', 'U+25B8', 'U+2022', 'U+FFED', 'U+25B8', 'U+2022', 'U+FFED', 'U+25B8', 'U+2022']
      },
      5: {
        mode: 'd',
        symbols: ['◦', '▸', '￭', '◦', '▸', '￭', '◦', '▸', '￭'],
        charCodes: ['U+25E6', 'U+25B8', 'U+25E6', 'U+25E6', 'U+25B8', 'U+25E6', 'U+25E6', 'U+25B8', 'U+25E6']
      }
    },
    maxLevel: 9,
    minLevel: 1
  },
  specialCharacters: {
    '^m': ' ', // em space
    '^>': ' ', // en space
    '^_': '—', // em dash
    '^=': '-', // en dash
    '^p': '¶', // paragraph symbol
    '^J': '§', // section symbol
    '^B': '•', // bullet character
    '^e': '…', // ellipsis
    '^|': ' ', // hair space
    '^<': ' ', // thin space
    '^/': ' ', // figure space
    '^.': ' ', // punctuation space
    '^t': '' // tab
  },
  orderedList: {
    marginIndent: 12,
    shortcut: '1. ',
    symbolMap: {
      1: 'numbers',
      2: 'letters',
      0: 'roman-numbers-lower'
    },
    defaultStyleId: 6,
    styles: {
      6: {
        mode: 'd',
        symbols: ['numbers', 'letters', 'roman-numbers-lower', 'numbers', 'letters', 'roman-numbers-lower', 'numbers', 'letters', 'roman-numbers-lower'],
        pattern: []
      },
      7: {
        mode: 'd',
        symbols: ['numbers', 'numbers', 'numbers', 'numbers', 'numbers', 'numbers', 'numbers', 'numbers', 'numbers'],
        pattern: ['^#^t', '^1.^#^t', '^1.^2.^#^t', '^1.^2.^3.^#^t', '^1.^2.^3.^4.^#^t', '^1.^2.^3.^4.^5.^#^t', '^1.^2.^3.^4.^5.^6.^#^t', '^1.^2.^3.^4.^5.^6.^7.^#^t', '^1.^2.^3.^4.^5.^6.^7.^8.^#^t']
      },
      8: {
        mode: 'd',
        symbols: ['roman-numbers', 'capital-letters', 'numbers', 'roman-numbers', 'capital-letters', 'numbers', 'roman-numbers', 'capital-letters', 'numbers'],
        pattern: []
      },
      9: {
        mode: 'd',
        symbols: ['capital-letters', 'letters', 'roman-numbers-lower', 'capital-letters', 'letters', 'roman-numbers-lower', 'capital-letters', 'letters', 'roman-numbers-lower'],
        pattern: []
      },
      10: {
        mode: 'd',
        symbols: ['numbers-with-two-digits', 'letters', 'roman-numbers-lower', 'numbers-with-two-digits', 'letters', 'roman-numbers-lower', 'numbers-with-two-digits', 'letters', 'roman-numbers-lower'],
        pattern: []
      }
    },
    maxLevel: 9,
    minLevel: 1
  },
  columns: {
    defaultColumns: 2,
    defaultGap: 10,
    minGap: 0,
    maxGap: 100
  },
  spacing: {
    maxLetterSpacing: 200,
    minLetterSpacing: -100
  },
  pagePaddingInPx: Theme.Spacing.Size.MediumSmall,
  overscan: 5,
  longTextLength: 100,
  initialPagesToFetch: 5,
  maxTextOverflowLength: 50,
  textBoxPadding: 5,
  textOverflowButtonOffset: 20,
  noBreakSpace: '\u00A0',
  defaultStyle: {
    seedContent: 'consetetur sadipscing elitr, sed diam',
    fontSize: 10,
    fontWeight: 400,
    fontFamily: 'Lato'
  },
  defaultFontWeight: {
    normal: 400,
    bold: 700
  },
  relativeFontWidth: 0.6,
  fontLigatureFactor: 0.99,
  fontWeightFactor: 0.96,
  quoteCharacters: {
    straightDoubleQuotes: '"',
    straightSingeQuote: '\'',
    closingDoubleQuotes: '”',
    closingSingeQuote: '’',
    openingDoubleQuotes: '“',
    openingSingleQuote: '‘'
  }
};

export const dpi = {
  variations: [72, 96]
};

export const NS = {
  HTML: 'http://www.w3.org/1999/xhtml',
  MATH: 'http://www.w3.org/1998/Math/MathML',
  SE: 'http://svg-edit.googlecode.com',
  SVG: 'http://www.w3.org/2000/svg',
  XLINK: 'http://www.w3.org/1999/xlink',
  XML: 'http://www.w3.org/XML/1998/namespace',
  XMLNS: 'http://www.w3.org/2000/xmlns/' // see http://www.w3.org/TR/REC-xml-names/#xmlReserved
};

export const fixPage = {
  quickFixVersion: 'thumb',
  defaultVersion: 'web',
  maxQuickFixVersion: 1024 * 1024 * 4, // 4 MB
  maxImageSize: 1024 * 1024 * 8, // 8 MB
  placeHolderImage: 'https://static.inkive.com/assets/img/placeholders/imageplaceholder_new.svg'
};

export const background = {
  image: 'svg_background_image',
  color: 'svg_background_color'
};

export const videoUploadLimit = {
  freeUser: 50000000,
  paidUser: 500000000
};

export const tableOfContents = {
  canvasLeftMargin: 24,
  tableFormat: 'classic',
  leaderStyle: 'none',
  levels: 5,
  isPageNumber: true,
  isAlignedRight: true,
  isLinkUsed: true,
  isMetadataExisted: false,
  defaultHeadingStyle: {
    0: {
      fontFamily: 'Nunito',
      fontSize: 24,
      fill: '#000000',
      marginLeft: 0,
      marginBottom: 24,
      size: 0.03,
      fontWeight: 400
    },
    1: {
      fontFamily: 'Nunito',
      fontSize: 14,
      fill: '#000000',
      size: 0.05,
      fontWeight: 700,
      marginLeft: 50,
      marginTop: 12,
      marginBottom: 4
    },
    2: {
      fontFamily: 'Nunito',
      fontSize: 10,
      fill: '#000000',
      size: 0.045,
      fontWeight: 700,
      marginLeft: 80,
      marginTop: 0,
      marginBottom: 4
    },
    3: {
      fontFamily: 'Nunito',
      fontSize: 10,
      fill: '#000000',
      size: 0.04,
      fontWeight: 600,
      marginLeft: 96,
      marginTop: 0,
      marginBottom: 4
    },
    4: {
      fontFamily: 'Nunito',
      fontSize: 10,
      fill: '#000000',
      size: 0.035,
      fontWeight: 600,
      marginLeft: 112,
      marginTop: 0,
      marginBottom: 4
    },
    5: {
      fontFamily: 'Nunito',
      fontSize: 10,
      fill: '#000000',
      size: 0.03,
      fontWeight: 600,
      marginLeft: 128,
      marginTop: 0,
      marginBottom: 4
    },
    pageNumber: {
      fontFamily: 'Nunito',
      fontSize: 10,
      fontWeight: 400,
      size: 0.05
    }
  },
  supportedStyles: [
    'fill',
    'font_family',
    'font_size',
    'font_weight',
    'font_style',
    'custom_font_id',
    'font_stretch',
    'list_fill',
    'list_font_size',
    'list_font_family',
    'list_font_weight',
    'list_custom_font_id',
    'list_font_style',
    'page_numbers',
    'leader',
    'align_page_numbers_right',
    'use_links'
  ],
  defaultCanvasWidth: 612,
  defaultCanvasHeight: 792,
  elementPadding: 6,
  offsetPercent: 0.12,
  maxHeadingWidthPercent: 0.7,
  extraRectWidth: 8,
  extraRectWidthForTitle: 20,
  minimumSize: 200 * 200, // pixels
  maxPages: 10
};

export const table = {
  defaultFontSize: 12,
  selectorMargin: 8,
  tableGripStyle: {
    fill: '#F2F4F8',
    stroke: '#D1D3D6'
  },
  corners: {
    fillColor: '#F2F4F8',
    borderColor: '#6F747C'
  }
};

export const colors = {
  bleedArea: '#FF0000',
  canvasBleedArea: '#0038FF',
  safeArea: '#1ECAA1',
  printGuideLines: '#D1D3D6',
  mugGuideline: '#0D7FFF',
  canvasBleedAreaPrinting: '#6F747C',
  numberGuidelines: '#131821',
  gripStyle: {
    fill: '#fff',
    stroke: '#E1E6EB'
  }
};

export const printingTypes = {
  bifold: {
    id: 'bifold',
    showBleed: true
  },
  trifold: {
    id: 'trifold',
    showBleed: true
  },
  accordion: {
    id: 'accordion',
    showBleed: true
  },
  'wire-o': {
    id: 'wire-o',
    showBleed: true
  },
  mug: {
    id: 'mug',
    showBleed: true,
    fixedPages: true
  },
  tote_bag: {
    id: 'tote_bag',
    img: {
      1: {
        url: 'https://static.desygner.com/assets/img/print/overlays/bag.png'
      },
      2: {
        url: 'https://static.desygner.com/assets/img/print/overlays/bag.png'
      }
    },
    thumb: {
      0: {
        width: 100,
        margin: '75px',
        size: '80%',
        url: 'https://static.desygner.com/assets/img/print/overlays/bag-thumb.png'
      },
      1: {
        width: 100,
        margin: '75px',
        size: '80%',
        url: 'https://static.desygner.com/assets/img/print/overlays/bag-thumb.png'
      }
    }
  },
  't-shirt_classic_premium': {
    id: 't-shirt_classic_premium',
    img: {
      1: {
        url: 'https://static.desygner.com/assets/img/print/overlays/shirt-front.png'
      },
      2: {
        url: 'https://static.desygner.com/assets/img/print/overlays/shirt-back.png'
      },
      3: {
        url: 'https://static.desygner.com/assets/img/print/overlays/inner-neck.png'
      },
      4: {
        url: 'https://static.desygner.com/assets/img/print/overlays/outer-neck.png'
      },
      5: {
        url: 'https://static.desygner.com/assets/img/print/overlays/sleeve-left.png'
      },
      6: {
        url: 'https://static.desygner.com/assets/img/print/overlays/sleeve-right.png'
      }
    },
    thumb: {
      0: {
        width: 70,
        height: 93.14,
        margin: '-30px',
        size: '100%',
        url: 'https://static.desygner.com/assets/img/print/overlays/shirt-front-thumb.png'
      },
      1: {
        width: 70,
        height: 93.14,
        margin: '-30px',
        size: '100%',
        url: 'https://static.desygner.com/assets/img/print/overlays/shirt-back-thumb.png'
      },
      2: {
        width: 50,
        height: 35.1,
        margin: 0,
        size: '180%',
        url: 'https://static.desygner.com/assets/img/print/overlays/inner-neck-thumb.png'
      },
      3: {
        hidden: true // ,
        // width: 50,
        // height: 35.1,
        // margin: '-60px',
        // size: '100%',
        // url: 'https://static.desygner.com/assets/img/print/overlays/outer-neck-thumb.png'
      },
      4: {
        width: 40,
        height: 36,
        margin: '-50px',
        size: '100%',
        url: 'https://static.desygner.com/assets/img/print/overlays/sleeve-left-thumb.png'
      },
      5: {
        width: 40,
        height: 36,
        margin: '-50px',
        size: '100%',
        url: 'https://static.desygner.com/assets/img/print/overlays/sleeve-right-thumb.png'
      }
    }
  }
};

export const eventTracker = {
  eventsAggregationDebounce: 500,
  clickTracking: 'dy-click',
  attributePrefix: 'dyA',
  metricPrefix: 'dyM'
};

export const cmykAttributes = {
  cmykFill: 'data-fill-cmyk',
  cmykStroke: 'data-stroke-cmyk'
};

export const contextMenu = {
  separator: '---------'
};

export const staticUrl = (INKIVE.C.IS_DEV || INKIVE.C.IS_QA)
  ? 'https://static.qadesygner.xyz/'
  : 'https://static.desygner.com/';

export const restrictions = {
  tableButtons: [
    'TEXT_FONTFAMILY',
    'TEXT_HEADING',
    'TEXT_FONTSIZE',
    'TEXT_FILL_COLOR',
    'TEXT_BOLD',
    'TEXT_ITALIC',
    'TEXT_UNDERLINE',
    'HIGHLIGHT_COLOR',
    'TEXT_LIST',
    'TEXT_BULLETS',
    'TEXT_ALIGN',
    'TEXT_SPACING',
    'TEXT_TYPING',
    'TEXT_CASE',
    'TEXT_COLUMNS',
    'TEXT_AUTO_ADJUSTABLE',
    'STROKE',
    'STROKE_COLOR',
    'PARAGRAPH_SPACING',
    'REMOVE_STYLE',
    'TEXT_LINK'
  ],
  tableEditExcludeButtons: [
    'RESTRICT_CHANGES',
    'ANIMATE',
    'LIBRARY_ADD',
    'LIBRARY_ADD_QUIET',
    'UNLINK',
    'TRANSFORM',
    'ROTATE',
    'DUPLICATE',
    'OPACITY',
    'ORDER',
    'ARRANGE',
    'ALIGNMENT',
    'LOCK',
    'UNLOCK',
    'REMOVE'
  ]
};

export const plans = {
  pro: 'pro',
  business: 'business',
  proTeam: 'pro_team',
  content2: 'content2'
};

export const loadingScreen = {
  videoUrl: 'https://static.desygner.com/assets/video/gradient.webm'
};
